(() => {
  const initialize = (section) => {
    if (
      !section ||
      section.dataset.croStickyCartInitialized === "true"
    ) {
      return;
    }

    section.dataset.croStickyCartInitialized = "true";

    const optionSelects = Array.from(
      section.querySelectorAll(
        "[data-cro-sticky-option]",
      ),
    );

    const variantInput = section.querySelector(
      "[data-cro-sticky-variant]",
    );

    const variantsScript = section.querySelector(
      "[data-cro-sticky-variants]",
    );

    const priceElement = section.querySelector(
      "[data-cro-sticky-price]",
    );

    const comparePriceElement =
      section.querySelector(
        "[data-cro-sticky-compare-price]",
      );

    const addButton = section.querySelector(
      "[data-cro-sticky-add]",
    );

    const buttonText = section.querySelector(
      "[data-cro-sticky-button-text]",
    );

    const statusElement = section.querySelector(
      "[data-cro-sticky-status]",
    );

    if (
      !variantInput ||
      !variantsScript ||
      !addButton ||
      !buttonText
    ) {
      return;
    }

    let variants = [];

    try {
      variants = JSON.parse(
        variantsScript.textContent || "[]",
      );
    } catch {
      variants = [];
    }

    const formatMoney = (amount) => {
      const value = Number(amount || 0) / 100;

      const currency =
        window.Shopify?.currency?.active ||
        "USD";

      try {
        return new Intl.NumberFormat(
          document.documentElement.lang || "en",
          {
            style: "currency",
            currency,
          },
        ).format(value);
      } catch {
        return `${currency} ${value.toFixed(2)}`;
      }
    };

    const findSelectedVariant = () => {
      const selectedOptions = optionSelects
        .slice()
        .sort(
          (first, second) =>
            Number(first.dataset.optionIndex) -
            Number(second.dataset.optionIndex),
        )
        .map((select) => select.value);

      if (!selectedOptions.length) {
        return variants.find(
          (variant) =>
            String(variant.id) ===
            String(variantInput.value),
        );
      }

      return variants.find(
        (variant) =>
          Array.isArray(variant.options) &&
          variant.options.length ===
            selectedOptions.length &&
          variant.options.every(
            (value, index) =>
              String(value) ===
              String(selectedOptions[index]),
          ),
      );
    };

    const showStatus = (
      message,
      type = "success",
    ) => {
      if (!statusElement) {
        return;
      }

      statusElement.textContent = message;
      statusElement.dataset.statusType = type;
      statusElement.classList.add("is-visible");

      window.clearTimeout(
        Number(
          statusElement.dataset.hideTimer || 0,
        ),
      );

      const timer = window.setTimeout(() => {
        statusElement.classList.remove(
          "is-visible",
        );
      }, 2800);

      statusElement.dataset.hideTimer =
        String(timer);
    };

    const updateVariant = () => {
      const variant = findSelectedVariant();

      const availableLabel =
        addButton.dataset.availableLabel ||
        "Add to cart";

      const soldOutLabel =
        addButton.dataset.soldOutLabel ||
        "Sold out";

      if (!variant) {
        variantInput.value = "";
        addButton.disabled = true;
        buttonText.textContent = "Unavailable";

        comparePriceElement?.classList.add(
          "is-hidden",
        );

        return;
      }

      variantInput.value = String(variant.id);

      if (priceElement) {
        priceElement.textContent =
          formatMoney(variant.price);
      }

      if (comparePriceElement) {
        const onSale =
          Number(variant.compare_at_price || 0) >
          Number(variant.price || 0);

        comparePriceElement.textContent =
          onSale
            ? formatMoney(
                variant.compare_at_price,
              )
            : "";

        comparePriceElement.classList.toggle(
          "is-hidden",
          !onSale,
        );
      }

      addButton.disabled = !variant.available;

      buttonText.textContent =
        variant.available
          ? availableLabel
          : soldOutLabel;
    };

    const updateVisibility = () => {
      const selectors = [
        'form[action*="/cart/add"] button[type="submit"]',
        'form[action*="/cart/add"] input[type="submit"]',
        '[name="add"]',
        "[data-add-to-cart]",
        ".product-form__submit",
      ];

      const primaryAddButton = Array.from(
        document.querySelectorAll(
          selectors.join(","),
        ),
      ).find(
        (element) =>
          !section.contains(element) &&
          element.offsetParent !== null,
      );

      if (!primaryAddButton) {
        section.classList.add("is-visible");
        return;
      }

      const bounds =
        primaryAddButton.getBoundingClientRect();

      const visible =
        bounds.bottom > 0 &&
        bounds.top < window.innerHeight;

      section.classList.toggle(
        "is-visible",
        !visible,
      );
    };

    optionSelects.forEach((select) => {
      select.addEventListener(
        "change",
        updateVariant,
      );
    });

    addButton.addEventListener(
      "click",
      async () => {
        const variantId = variantInput.value;

        if (
          !variantId ||
          addButton.disabled
        ) {
          return;
        }

        addButton.disabled = true;
        addButton.classList.add("is-loading");
        buttonText.textContent = "Adding...";

        try {
          const root =
            window.Shopify?.routes?.root ||
            "/";

          const normalizedRoot =
            root.endsWith("/")
              ? root
              : `${root}/`;

          const response = await fetch(
            `${normalizedRoot}cart/add.js`,
            {
              method: "POST",
              credentials: "same-origin",
              headers: {
                "Content-Type":
                  "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({
                items: [
                  {
                    id: Number(variantId),
                    quantity: 1,
                  },
                ],
              }),
            },
          );

          const result =
            await response.json();

          if (!response.ok) {
            throw new Error(
              result.description ||
              result.message ||
              "Unable to add this product.",
            );
          }

          showStatus("Added to your cart");

          document.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: result,
            }),
          );

          document.dispatchEvent(
            new CustomEvent("cart:updated", {
              bubbles: true,
              detail: {
                product: result,
                source: "cro-sticky-cart",
              },
            }),
          );

          document.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: result,
            }),
          );
        } catch (error) {
          showStatus(
            error instanceof Error
              ? error.message
              : "Unable to add this product.",
            "error",
          );
        } finally {
          addButton.classList.remove(
            "is-loading",
          );

          updateVariant();
        }
      },
    );

    window.addEventListener(
      "scroll",
      updateVisibility,
      {
        passive: true,
      },
    );

    window.addEventListener(
      "resize",
      updateVisibility,
      {
        passive: true,
      },
    );

    updateVariant();
    updateVisibility();

    window.setTimeout(
      updateVisibility,
      300,
    );
  };

  const initializeAll = (root = document) => {
    if (root.matches?.("[data-cro-sticky-cart]")) {
      initialize(root);
    }

    root
      .querySelectorAll?.(
        "[data-cro-sticky-cart]",
      )
      .forEach(initialize);
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => initializeAll(),
    );
  } else {
    initializeAll();
  }

  document.addEventListener(
    "shopify:section:load",
    (event) => initializeAll(event.target),
  );
})();
